import { Component, OnDestroy, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

import { Observable, Subscription, filter, distinctUntilChanged } from 'rxjs';

import { unsubscribe } from '@fcom/core/utils';
import { CookieService } from '@fcom/core';
import { LanguageService } from '@fcom/ui-translate';

import { SchemaService, NavigationMenuService, ScrollService } from '../../services';
import { isNavigationEvent } from '../../utils';

export const INDIA_REDIRECT_COOKIE = 'india-redirect';
export const INDIA_REDIRECT_CLOSED_COOKIE = 'india-redirect-closed';

@Component({
  selector: 'fin-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: [],
  standalone: false,
})
export class BaseLayoutComponent implements OnDestroy {
  private navigationMenuService = inject(NavigationMenuService);
  private router = inject(Router);
  private scrollService = inject(ScrollService);
  private cookieService = inject(CookieService);
  private languageService = inject(LanguageService);
  private schemaService = inject(SchemaService);
  private platform = inject(PLATFORM_ID);

  subscriptions: Subscription = new Subscription();
  isFooterOpen$: Observable<boolean>;
  showIndiaRedirectNotification = false;

  constructor() {
    this.subscriptions.add(
      this.router.events
        .pipe(
          filter(isNavigationEvent),
          filter(() => isPlatformBrowser(this.platform)),
          distinctUntilChanged((o: NavigationEnd, n) => o.url.split('?')[0] === n.url.split('?')[0]) // If path changed (not only parameters)
        )
        .subscribe(() => {
          this.scrollService.scrollTop();
          this.schemaService.clearSchemas();
        })
    );
    this.isFooterOpen$ = this.navigationMenuService.isFooterOpen$;

    if (
      this.cookieService.getItem(INDIA_REDIRECT_COOKIE) &&
      isPlatformBrowser(this.platform) &&
      !this.cookieService.getItem(INDIA_REDIRECT_CLOSED_COOKIE) &&
      this.languageService.localeValue === 'en'
    ) {
      this.showIndiaRedirectNotification = true;
      this.cookieService.removeItem(INDIA_REDIRECT_COOKIE, '/', 'www.finnair.com');
    }
  }

  onCloseIndiaNotification(): void {
    this.showIndiaRedirectNotification = false;
    this.cookieService.setItem(INDIA_REDIRECT_CLOSED_COOKIE, true);
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
